import React, { useEffect, useState } from "react";
import TemplateLibraryIcon from "../../assets/icons/template_rec.svg2";
import LibraryLinks from "./LibraryLinks";
import PageHeader from "../Common/PageHeader";
import MySearch from "../Common/MySearch";
import ImportedContactFilesList from "./ImportedContactFilesList";
import ImportContactsModal, {
  ImportedContactFileInfoType,
} from "../Broadcast/ImportContactsModal";
import { Link } from "react-router-dom";
import importedContactsLibraryIcon from "../../assets/icons/contacts_main (1).svg2";
import LibraryIcon from "../../assets/icons/library_puzzle.svg2";
import Subheading from "../Common/Subheading";
import ImportedContactFilesLibraryIcon from "../../assets/icons/icon_contacts-01.svg2";
import ImportedContactFilesFilters from "./ImportedContactFilesFilters";
import { proxyAPI } from "../proxyAPI";
import ExportContacts from "./ExportContacts";
import MyModal from "../Common/MyModal";
import WhiteButton from "../Common/WhiteButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function ImportedContactFilesLibrary() {
  const [forceRefresh, setForceRefresh] = useState(new Date().toLocaleString());
  const [filters, setFilters] = useState<{ status?: string; search?: string }>({
    status: "processed",
  });
  const actionButton = (f: ImportedContactFileInfoType) => (
    <Link
      to={`/library/broadcast/new/messages`}
      className="btn bg-colored text-white"
      state={{ importedContactFile: f }}
    >
      use file
    </Link>
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <Subheading
          Icon={ImportedContactFilesLibraryIcon}
          heading="Imported Contacts Files Library"
          subheading="Access your temporary and up-loaded contacts"
        />
        <div className="d-flex justify-content-end gap-2">
          <WhiteButtonDropdown
            toggleHeading={"Actions"}
            toggleSubheading={"Imported Contacts Files Library"}
          >
            <MyModal
              label={
                <WhiteButton
                  as="span"
                  heading={"Export"}
                  subheading="Contacts"
                  icon={ImportedContactFilesLibraryIcon}
                  target={undefined}
                  disabled={false}
                />
              }
              heading="Export Contacts"
              size="xxl"
            >
              <div style={{ minHeight: 400 }}>
                <ExportContacts />
              </div>
            </MyModal>
            <div className="border border-2 rounded-3">
              <ImportContactsModal
                setFile={() => {
                  setForceRefresh(new Date().toLocaleString());
                }}
                matchByAutomatically
              />
            </div>
          </WhiteButtonDropdown>
        </div>
      </div>
      <div className="mb-3 p-3 rounded-3 bg-colored-reverse d-flex justify-content-between  border border-2">
        <ImportedContactFilesFilters
          filters={filters}
          setFilters={setFilters}
        />
      </div>
      <ImportedContactFilesList
        actionButton={actionButton}
        key={forceRefresh}
        filters={filters}
        showSaveContactsButton
      />
    </div>
  );
}
